import {
  cilAccountLogout,
  cilAddressBook,
  cilBeachAccess,
  cilBed,
  cilBell,
  cilBoatAlt,
  cilCalendar,
  cilCalendarCheck,
  cilCart,
  cilChevronBottom,
  cilChevronLeft,
  cilClearAll,
  cilCog,
  cilDialpad,
  cilEnvelopeClosed,
  cilFlightTakeoff,
  cilGlobeAlt,
  cilList,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMenu,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPlus,
  cilReload,
  cilRoom,
  cilSend,
  cilSpeedometer,
  cilTrash,
  cilUser
} from '@coreui/icons'
import { logo } from './logo'
import { logoMobile } from './logoMobile'

export const iconsSet = {
  cilAccountLogout,
  cilAddressBook,
  cilBeachAccess,
  cilBed,
  cilBell,
  cilBoatAlt,
  cilCalendar,
  cilCalendarCheck,
  cilCart,
  cilChevronBottom,
  cilChevronLeft,
  cilClearAll,
  cilCog,
  cilDialpad,
  cilEnvelopeClosed,
  cilFlightTakeoff,
  cilGlobeAlt,
  cilList,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMenu,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPlus,
  cilReload,
  cilRoom,
  cilSend,
  cilSpeedometer,
  cilTrash,
  cilUser,
  logo,
  logoMobile
}
